import React from 'react';
import classNames from 'classnames';
import { CUSTOM_DESTINATION_OPTIONS } from '../../../stores/types/broadcasting';
import { SelectGroupOption } from '../../general-components/select-group';

interface Props {
	buttonCallback: Function;
	buttonClassNames?: string;
}

export default function StreamingDestinations(props: Props) {
	const {
		buttonCallback,
		buttonClassNames,
	} = props;

	return (<>
		{CUSTOM_DESTINATION_OPTIONS.map((d: SelectGroupOption, index: number) => (
			<button
				key={index}
				onClick={() => buttonCallback(d)}
				className={classNames(buttonClassNames)}
			>
				<img
					src={d.description ?? ''}
					alt={d.label ?? ''}
					className='image margin-right-medium'
				/>
				<span className='text text-transform-capitalize text-white'>
					{d.label ?? ''}
				</span>
			</button>
		))}
	</>);
}
